import axios from 'axios';

class IntegrationService {
  static async connectGoogleCalendar(name) {
    try {
      const response = await axios.get('/integrations/google-calendar', {
        params: name ? { name } : undefined,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Google Calendar URL:', error);
      throw error;
    }
  }
  static async connectOutlookCalendar(name, { popup = false } = {}) {
    try {
      const params = {};
      if (name) params.name = name;
      if (popup) params.popup = 'true';
      const response = await axios.get('/integrations/outlook-calendar', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching Outlook Calendar URL:', error);
      throw error;
    }
  }
  static async getOutlookAdminConsentUrl() {
    try {
      const response = await axios.get('/integrations/outlook-calendar/admin-consent');
      return response.data;
    } catch (error) {
      console.error('Error fetching Outlook admin consent URL:', error);
      throw error;
    }
  }
  static async listCalendars(integration) {
    try {
      const response = await axios.get(`/integrations/google-calendar/calendars`);
      return response.data;
    } catch (error) {
      console.error('Error fetching calendars:', error);
      throw error;
    }
  }

  static async listOutlookCalendars(integrationId) {
    try {
      const response = await axios.get(`/integrations/outlook-calendar/${integrationId}/calendars`);
      return response.data;
    } catch (error) {
      console.error('Error fetching Outlook calendars:', error);
      throw error;
    }
  }

  // Returns a fully-hydrated integration including the `settings` JSONB and
  // its `form_integrations` (with per-form settings). Used to lazy-load the
  // detail data that the slim /integrations list no longer ships.
  static async getById(id) {
    const response = await axios.get(`/integrations/${id}`);
    return response.data;
  }
}

export default IntegrationService;
